<template>
  <div class="min-h-full bg-cream px-4 pt-12 pb-24">
    <ProfilePageHeader title="Продукты в рационе" />

    <h2 class="field-title">Исключения из рациона</h2>
    <p class="field-hint">Эти продукты Зоя не предложит ни в рационе, ни в рецептах</p>
    <textarea
      v-model="allergies"
      rows="5"
      placeholder="Напишите сюда продукты, которые важно исключить при формировании вашего рациона по любой причине"
      class="w-full mb-5 px-4 py-4 rounded-2xl bg-tip text-14 text-ink outline-none border-0 resize-none leading-relaxed"
      style="font-family: Inter, sans-serif;"
    />

    <h2 class="field-title">Предпочтения</h2>
    <p class="field-hint">Зоя будет выбирать эти продукты, когда это уместно</p>
    <textarea
      v-model="foodPreferences"
      rows="5"
      placeholder="Напишите сюда продукты и блюда, которые вы любите"
      class="w-full mb-4 px-4 py-4 rounded-2xl bg-tip text-14 text-ink outline-none border-0 resize-none leading-relaxed"
      style="font-family: Inter, sans-serif;"
    />

    <!-- Автосохранение статус -->
    <p v-if="saveStatus" class="text-12 text-ink/70 text-center mb-4">{{ saveStatus }}</p>

    <!-- Назад в Профиль -->
    <button
      @click="$router.push('/profile')"
      class="w-full py-3 rounded-2xl bg-ink text-cream text-15 font-semibold"
    >
      Назад в Профиль
    </button>
  </div>
</template>

<script setup>
import ProfilePageHeader from '../components/ProfilePageHeader.vue'
import { ref, watch, onMounted, nextTick } from 'vue'
import { useAuthStore } from '../store/auth.js'

const authStore = useAuthStore()
const allergies = ref(authStore.user?.allergies || '')
const foodPreferences = ref(authStore.user?.food_preferences || '')
const saveStatus = ref('')
let saveTimer = null
const isReady = ref(false)

onMounted(() => { nextTick(() => { isReady.value = true }) })

// Одно сохранение на оба поля: они правятся на одном экране, и отправлять
// два запроса подряд незачем — на сервере это всё равно один PATCH профиля.
function scheduleSave() {
  if (!isReady.value) return
  saveStatus.value = ''
  clearTimeout(saveTimer)
  saveTimer = setTimeout(async () => {
    try {
      saveStatus.value = 'Сохранение...'
      await authStore.updateProfile({
        allergies: allergies.value.trim() || null,
        food_preferences: foodPreferences.value.trim() || null,
      })
      saveStatus.value = 'Сохранено'
      setTimeout(() => { if (saveStatus.value === 'Сохранено') saveStatus.value = '' }, 2000)
    } catch {
      saveStatus.value = 'Ошибка сохранения'
    }
  }, 1000)
}

watch(allergies, scheduleSave)
watch(foodPreferences, scheduleSave)
</script>

<style scoped>
.field-title {
  font-size: var(--fs-17);
  font-weight: 700;
  color: var(--ink);
  margin-bottom: 2px;
}
.field-hint {
  /* Тот же кегль, что у текста в поле — 14px */
  font-size: var(--fs-14);
  color: var(--ink-70);
  line-height: 1.3;
  margin-bottom: 8px;
}
/* Поле повторяет заметку приёма пищи в дневнике: жёлтая подложка,
   коричневый текст, плейсхолдер тем же цветом, но прозрачнее. */
textarea::placeholder {
  color: var(--ink-70);
}
</style>
